function toPixelString(num) {
    const array = Array.isArray(num) ? num : [
        num
    ];
    return array.map((val)=>`${val}px`).join(' ');
}
export { toPixelString };

//# sourceMappingURL=to-pixel-string.js.map